<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div class="absolute h-[calc(100%-140px)] w-540px left-35px top-66px z-100">
    <el-tooltip
      :content="showPanel ? '收缩地下管网' : '展开地下管网'"
      placement="right"
      :open-delay="1000"
    >
      <div
        class="w-34px h-34px rounded-tl-2px rounded-tr-5px rounded-br-5px
          rounded-bl-2px bg-[#00c0ff] top-0px -left-34px text-center
          cursor-pointer absolute text-[#fff]"
        @click="showPanel = !showPanel"
      >
        <span class="iconfont icon-bg-setup text-18px !leading-34px"></span>
      </div>
    </el-tooltip>
    <div class="p-10px component-container h-full" v-show="showPanel">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        地下管网
      </div>
      <div class="flex">
        <selectStandardId
          @updateStandardId="updateStandardId"
          class="!w-140px"
          :selectStandardProps="{ popperClass: 'document_select-popper' }"
        />
        <el-select
          class="w-full ml-10px flex-1"
          v-model="modelDocumentId"
          popper-class="document_select-popper"
          clearable
          filterable
          size="mini"
          placeholder="模型下拉选择"
          @change="changeCurrentModel"
        >
          <el-option
            v-for="item in modelList"
            :key="item.id"
            :label="item.fileNameOrigin"
            :value="item.documentId"
          ></el-option>
        </el-select>
        <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="operateClip(1)"
            icon="iconfont icon-yxr-move"
            :class="{ 'is-active': activeType === 1 }"
            class="ml-10px rounded-1/2 w-36px p-0"
          ></el-button>
        </el-tooltip>
      </div>
      <div class="flex mt-10px items-center">
        <el-input
          v-model="keyword"
          size="mini"
          class="mr-10px !w-140px"
          placeholder="请输入代码或名称"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-input
          v-model="medium"
          size="mini"
          class="mr-10px flex-1"
          placeholder="请输入介质"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="searchList"
            icon="iconfont icon-line-search"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="对象信息" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="$emit('showBitRelational')"
            icon="iconfont icon-bg-language"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="地面点位" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="resetPos"
            icon="iconfont icon-yxr-globalSection"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="地下管道" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="searchList"
            icon="iconfont icon-yxr-undergroundExcavation"
            :disabled="!clipObjectShow"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="导出" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="exportData"
            icon="iconfont icon-line-download"
            :disabled="!tableData.length"
            :loading="exportLoading"
          ></el-button>
        </el-tooltip>
      </div>
      <div class="px-10px flex items-center text-[#fff] text-12px">
        <span class="mr-10px">透明度</span>
        <el-slider
          v-model="colorPickupBkAlpha"
          :min="0"
          :max="1"
          :step="0.1"
          class="w-full flex-1"
        />
      </div>
      <el-table
        ref="markerTable"
        :data="tableData"
        :empty-text="isEmptyData ? '该地面点位下，无地下管道' : ' '"
        v-loading="tableLoading"
        height="calc(100% - 216px)"
        :row-key="(row) => row.tagId"
        class="mt-10px"
        :class="{
          'is-empty-data': isEmptyData,
        }"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="true"
        @row-click="moveToPipe"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagCode" label="代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagName" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="medium" label="介质"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="discipline" label="专业"></el-table-column>
      </el-table>
      <div class="mt-10px text-right">
        <el-pagination
          small
          background
          @current-change="getTableData"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'xlsx'
import DocumentManagementService from '@/services/documentManagement'
import ThreeDimensionsService from '@/services/ThreeDimensions'
import ApiMixinDocument from '@/assets/js/api/documents'
import selectStandardId from '@/modules/resource/components/selectStandardId'

export default {
  name: 'undergroundPipe',
  mixins: [ApiMixinDocument],
  components: {
    selectStandardId,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showPanel: true,
      standardId: localStorage.getItem('standardId'),
      modelDocumentId: '',
      modelList: [], // 模型列表
      keyword: '',
      medium: '',
      allModelList: [], // 所有模型列表
      colorPickupBkAlpha: 0.2,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      activeType: 0,
      clipObjectShow: false,
      isEmptyData: false,
      pipeCodes: [],
      exportLoading: false,
      currentRow: null,
    }
  },
  computed: {},
  watch: {
    colorPickupBkAlpha: {
      async handler(val) {
        await this.renderVignette(val)
      },
    },
  },
  methods: {
    async operateClip(type) {
      if (!this.clipObjectShow) return
      if (this.activeType && this.activeType === type) {
        await this.player.Native.Node.setAxisEditType(0)
        this.activeType = 0
      } else {
        await this.player.Native.Node.setAxisEditType(type)
        this.activeType = type
      }
    },
    resetPos() {
      this.initCrossSection()
      // 重置生成的数据
      this.resetData()
    },

    async searchList() {
      if (!this.clipObjectShow) return
      try {
        this.tableData = []
        this.page.pageNo = 1
        this.page.total = 0
        this.tableLoading = true
        this.isEmptyData = false
        this.activeType = 0
        // 获取根节点
        const rootList = await this.player.Native.Node.getRoot()
        // 获取圆柱体
        const geoType = await this.player.Native.Node.collectNodesByGeoType(rootList, 8)
        // 获取点位信息
        const anchorPos = await this.player.Native.Camera.getAnchorPos()
        // 获取所有数据
        const nodeList = await this.player.Native.PrjFunc.getNodesUnderFace(geoType, {
          position: anchorPos,
          direction: [0, 0, 1],
        })
        this.player.Native.Setting.set('display.bgTransparent.alpha', this.colorPickupBkAlpha)
        this.player.Native.Setting.set('display.bgTransparent.enable', true)
        const reg = new RegExp(
          '^\\d{4}-(?:-?\\d+(?:\\.\\d+)?(?:e[-+]?\\d+)?|\\d+(?:/\\d+))"-[A-Z0-9]{1,4}-[A-Z0-9]{1,6}[A-Z]{0,1}(-.{0,7})?(-.{0,2})?$'
        )
        this.pipeCodes = []
        _.forEach(nodeList, (item) => {
          if (reg.test(item.code)) {
            this.pipeCodes.push(item.code)
          }
        })
        this.getTableData()
      } catch (error) {
        this.tableLoading = false
      }
    },
    async getData(params) {
      const res = await ThreeDimensionsService.getPipelineMatchList(params)
      return res
    },
    // 获取管线表数据
    async getTableData() {
      this.tableLoading = true
      if (this.pipeCodes.length) {
        const res = await this.getData({
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
          maxResultCount: this.page.pageSize,
          standardId: this.standardId,
          modelFileId: this.modelDocumentId
            ? _.find(this.modelList, ['documentId', this.modelDocumentId]).fileIdOrigin
            : '',
          filter: this.keyword,
          medium: this.medium,
          codes: this.pipeCodes,
        })
        if (res?.code === 0) {
          this.tableData = res.data
          this.page.total = res.totalCount
        }
      } else {
        this.isEmptyData = true
      }
      this.tableLoading = false
    },
    // 重置数据
    async resetData() {
      this.tableData = []
      this.isEmptyData = false
      this.tableLoading = false
      this.page.pageNo = 1
      this.page.total = 0
      this.activeType = 0
      this.currentRow = null
      if (!this.clipObjectShow) return
      await this.player.Native.Node.unSelectNodes([]) // 取消选中
      await this.player.Native.Node.setAxisEditType(0) // 取消三维操作模式
      await this.player.Native.Node.removeNodeFromAxisEdit(this.clipObject) // 取消三维编辑轴
      await this.player.Native.ClipBox.setEnable(false) // 取消断面剖切效果
      await this.player.Native.ClipBox.setProperty(this.clipObject, { visible: false }) // 隐藏断面
      await this.player.Native.Setting.set('display.bgTransparent.enable', false)
      this.renderVignette(1)
      this.clipObjectShow = false
    },
    async initCrossSection() {
      const anchorPos = await this.player.Native.Camera.getAnchorPos()
      this.clipObject = await this.player.Native.ClipBox.activeClip()
      this.player.Native.ClipBox.setClipType(this.clipObject, 1)
      const currentParam = await this.player.Native.Camera.currentParam()
      this.player.Native.ClipBox.setProperty(this.clipObject, {
        visible: true,
        frontColor: this.convertTo0xFormat('#FF004D'),
      })
      this.clipObjectShow = true
      this.player.Native.ClipBox.initByPoint(
        this.clipObject,
        anchorPos,
        // Vec3.sub(currentParam.eye, anchorPos),
        Vec3.sub([anchorPos[0], anchorPos[1], currentParam.eye[2]], anchorPos),
        [20, 20]
      )
      this.player.Native.ClipBox.initByPoint(
        this.clipObject,
        anchorPos,
        // Vec3.sub(currentParam.eye, anchorPos),
        Vec3.sub([anchorPos[0], anchorPos[1], currentParam.eye[2]], anchorPos),
        [20, 20]
      )
      this.player.Native.ClipBox.setEnable(false)
      this.player.Native.Node.addNodeToAxisEdit(this.clipObject)
      const eye = [anchorPos[0], anchorPos[1], currentParam.eye[2]]
      this.sectionInfo = { eye, anchorPos }
    },
    convertTo0xFormat(color) {
      if (color.startsWith('#')) {
        color = color.slice(1)
      }
      return parseInt(`0x${color}30`, 16)
    },
    updateStandardId(val) {
      this.standardId = val
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    },
    // 切换模型
    async changeCurrentModel(val) {
      // 获取model详情
      const model = await this.getModelFileDetail(val)
      if (!_.isEmpty(model)) {
        this.$emit('changeModelData', model)
      }
      this.resetData()
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getModelFileDetail(id) {
      const res = await DocumentManagementService.getDocumentDetail({
        id,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        if (_.isEmpty(fileDetail)) {
          return {}
        }
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        fileDetail.classId = res.data.documentBaseInfo.classId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.last(_.split(fileDetail.fileName, '.')).toLowerCase()
        return fileDetail
      }
      return {}
    },
    async getModelList() {
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          id: this.documentId,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data
      }
      return []
    },
    async markerHover(item) {
      const newimgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,127')
      if (item.markerId !== 0) {
        await this.player.Native.GisMarker.setProperty(item.markerId, {
          imgId: newimgId,
          textColor: 0xffffffff,
        })
      }
    },
    async markerLeave(item) {
      // 创建一个透明的图片，用于隐藏
      const imgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,0')
      await this.player.Native.GisMarker.setProperty(item.markerId, {
        imgId,
        textColor: 0xffffff00,
      })
    },
    async renderVignette(val) {
      if (_.isEmpty(this.player)) return
      // 调整alpha通道值
      await this.player.Native.Setting.set('display.bgTransparent.alpha', val)
      // 选中表格中勾选的模型节点
      const rootNode = await this.player.Native.Node.getRoot()
      if (!rootNode || !this.clipObjectShow || !this.currentRow) return
      const codeData = await this.player.Native.Node.findNode(rootNode, {
        codes: [this.currentRow.tagCode],
      })
      const codes = codeData?.codes
      if (codes && codes[this.currentRow.tagCode] && codes[this.currentRow.tagCode].node) {
        this.player.Native.Node.selectNodes([codes[this.currentRow.tagCode].node])
      }
    },
    async moveToPipe(row) {
      if (row.tagCode) {
        this.currentRow = row
        this.$emit('getModelData', {
          isTag: true,
          businessId: row.tagId,
          code: row.tagCode,
        })
        this.activeType = 0
        await this.player.Native.Node.setAxisEditType(0)
        await this.player.Native.Node.unSelectNodes([])
        this.player.Native.ClipBox.setEnable(false)
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.tagCode],
        })
        const codes = codeData?.codes
        if (codes && codes[row.tagCode] && codes[row.tagCode].node) {
          // 计算节点包围盒
          const nodeInfo = await this.player.Native.Node.getProperty(codes[row.tagCode].node, [
            'aabb',
          ])
          const calculateValue = (aabb) => {
            const minPoint = aabb[0]
            const maxPoint = aabb[1]

            const dx = maxPoint[0] - minPoint[0]
            const dy = maxPoint[1] - minPoint[1]
            const dz = maxPoint[2] - minPoint[2]

            const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
            const value = 0 + 6.5 / (1 + Math.log(L + 1))
            return value
          }
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithDistance(
            nodeInfo.aabb,
            2,
            25,
            calculateValue(nodeInfo.aabb)
          )
          this.player.Native.Node.selectNodes([codes[row.tagCode].node])
        }
      }
    },
    async exportData() {
      try {
        this.exportLoading = true
        const res = await this.getData({
          skipCount: 0,
          maxResultCount: 9999999,
          standardId: this.standardId,
          modelFileId: this.modelDocumentId
            ? _.find(this.modelList, ['documentId', this.modelDocumentId]).fileIdOrigin
            : '',
          filter: this.keyword,
          medium: this.medium,
          codes: this.pipeCodes,
        })
        if (res?.code === 0) {
          const headers = ['序号', '代码', '名称', '介质', '专业']
          const result = [
            headers,
            ..._.map(res.data, (item, index) => {
              return [index + 1, item.tagCode, item.tagName, item.medium, item.discipline]
            }),
          ]
          const workbook = XLSX.utils.book_new()
          const worksheet = XLSX.utils.aoa_to_sheet(result)
          worksheet['!cols'] = _.map(headers, (item) => {
            return { wch: item === '序号' ? 10 : 34 }
          })
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
          XLSX.writeFile(workbook, '地下管网.xlsx')
        }
        this.exportLoading = false
      } catch (error) {
        console.error(error)
        this.exportLoading = false
      }
    },
  },
  async created() {
    this.allModelList = await this.getModelList()
    if (this.standardId) {
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
    }
  },
  beforeDestroy() {
    this.resetData()
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}
.is-active {
  background: linear-gradient(#003d73, #3a94e1) !important;
  border: none;
}
::v-deep .el-table.is-empty-data {
  .el-table__empty-block {
    &::before {
      display: none;
    }
    .el-table__empty-text {
      display: block;
    }
  }
}

</style>
